import TableSelector from 'components/Pages/FundsCenter/AllFunds/FundsListing/TableSelector';
import DisplayingRange from 'components/includes/DisplayingRange';

type FundListingHeadingProps = {
  totalFunds: number;
  currentPage: number;
  take: number;
  allFundsTabTabs: [
    {
      key: string;
      title: string;
    }
  ];
  isLoading: boolean;
};

const FundsListingHeading = ({
  totalFunds,
  currentPage,
  take,
  allFundsTabTabs,
  isLoading,
}: FundListingHeadingProps) => {
  return (
    <div className="funds-listing__heading d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-3 mb-xl-0">
      <TableSelector allFundsTabTabs={allFundsTabTabs} />
      <DisplayingRange
        className="footnote text-grey mt-4 mt-lg-0"
        dictionaryKey="paginationDisplayingResults"
        total={totalFunds}
        take={take}
        page={currentPage}
        showSkeleton={isLoading}
      />
    </div>
  );
};

export default FundsListingHeading;
